// Google Analytics 4 helpers for SPA
const GA_ID = "G-R61RT8Y2RE";

export function gaReady() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

export function trackPageView(path) {
  if (!gaReady()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_ID,
  });
}

export function trackEvent(name, params = {}) {
  if (!gaReady()) return;
  window.gtag("event", name, { ...params, send_to: GA_ID });
}
